function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.2 19.2a2.397 2.397 0 00-2.388 2.4c0 1.32 1.068 2.4 2.388 2.4 1.32 0 2.4-1.08 2.4-2.4 0-1.32-1.08-2.4-2.4-2.4zM0 0v2.4h2.4l4.32 9.108-1.62 2.94a2.32 2.32 0 00-.3 1.152c0 1.32 1.08 2.4 2.4 2.4h14.4v-2.4H7.704a.297.297 0 01-.3-.3l.036-.144L8.52 13.2h8.94c.9 0 1.692-.492 2.1-1.236l4.296-7.788A1.204 1.204 0 0022.8 2.4H5.052L3.924 0H0zm19.2 19.2a2.397 2.397 0 00-2.388 2.4c0 1.32 1.068 2.4 2.388 2.4 1.32 0 2.4-1.08 2.4-2.4 0-1.32-1.08-2.4-2.4-2.4z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    color: "currentColor"
  }, props), _ref);
}

export default SvgCartIcon;